import PropTypes from 'prop-types'
import ProductListTransactional from '#src/products/components/list/v2/product-list-transactional'
import ProductListNonTransactional from '#src/products/components/list/v2/product-list-non-transactional'

const List = ({
  isTransactional,
  selectedCategoryName,
  selectedCategory,
  selectedSubCategory,
  ...props
}) => {
  return isTransactional ? (
    <ProductListTransactional
      {...props}
      selectedCategoryName={selectedCategoryName}
    />
  ) : (
    <ProductListNonTransactional
      {...props}
      selectedCategory={selectedCategory}
      selectedSubCategory={selectedSubCategory}
    />
  )
}

List.propTypes = {
  isTransactional: PropTypes.bool,
  selectedCategoryName: PropTypes.string
}

export default List
